import { mapURL } from 'core-lib/data/common';
import { useRouter } from 'next/router';
import { Typography } from 'ui';
import { TypeScales } from 'ui/primitives';
import s from './NewsCard.module.scss';


export const NewsCard = ({
  image,
  heading,
  subheading,
  url,
}: {
  image: string;
  heading: string;
  subheading: string;
  url: string;
}) => {
  const router = useRouter();
  function handleLinkClick() {
    router?.push(url);
  }
  return (
    <div className={s.root} onClick={handleLinkClick}>
      <figure className={s.image}>
        {image && <img src={mapURL(image)} alt="news_thumbnail" />}
      </figure>
      <div className={s.bottom}>
        <Typography className={s.title} label={heading} />
        <Typography
          className={s.clipped_text}
          variant={TypeScales.body_big_r}
          label={subheading}
        />
        <a href={url} className={s.link}>
          <Typography label="Read more" variant={TypeScales.body_m} />
        </a>
      </div>
    </div>
  );
};
